import styled, { keyframes } from "styled-components";

export const Container = styled.div`
  padding: 10px 32px;

  .go_back_btn {
    background-color: transparent;
    color: #000;
    font-size: 19px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    border: none;
    margin-bottom: 20px;
    cursor: pointer;
  }
`;

export const Forms = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
  gap: 32px;
  /* flex-direction: column; */

  .content {
    display: flex;
    flex-direction: column;
    gap: 32px;
    width: 100%;
    small {
      max-width: 400px;
    }
  }

  .buttons {
    display: flex;
    flex-wrap: wrap;
    gap: 16px;
  }

  .collab__wrapper {
    /* margin-top: 2rem; */
  }
`;

const spin = keyframes`
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
`;

export const ButtonContainer = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 32px;
  width: 100%;

  button {
    background-color: var(--color-primary);
    color: #fff;
    font-size: 16px;
    font-weight: 600;
    line-height: normal;
    cursor: pointer;
    padding: 8px 10px;
    border-radius: 4px;
    border: none;

    &:hover {
      background: var(--color-primary-dark);
    }
  }

  .load {
    border: 2px solid #fff;
    border-radius: 50%;
    border-top: 2px solid #a0a0a0;
    width: 20px;
    height: 20px;

    animation: ${spin} 1s linear infinite;
  }
`;

export const Header = styled.div`
  display: flex;
  flex-direction: column;
  border-bottom: 1px solid #96989a;
  margin: 24px 0 2rem 0;
  padding-bottom: 1rem;

  h3 {
    font-size: 19px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    margin-bottom: 8px;
  }

  div {
    display: flex;
    justify-content: space-between;
    gap: 1rem;
    align-items: center;

    h1 {
      color: #000;
      font-size: 24px;
      font-style: normal;
      font-weight: 700;
      line-height: normal;
      margin-bottom: 8px;
    }

    span {
      display: flex;
      align-items: center;
      gap: 8px;
      font-size: 24px;
      font-style: normal;
      font-weight: 400;
      line-height: normal;
    }
  }
`;

export const ManagersContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-top: 2rem;

  h3 {
    font-size: 22px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
    margin-bottom: 8px;
  }

  div {
    display: flex;
    align-items: center;
    gap: 8px;
  }

  .manager__wrapper {
    display: flex;
    flex-direction: column;
    align-items: flex-start;

    > label {
      font-size: 16px;
      line-height: normal;
    }

    > span {
      width: 100%;
      display: flex;
      align-items: center;
    }
  }

  input {
    border: 1px solid #96989a;
    padding: 8px 10px;
    border-radius: 4px;
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    flex: 1;

    &:disabled {
      background-color: #96989a;
      border: 1px solid #96989a;
    }
  }

  button {
    border: none;
    background-color: transparent;
    cursor: pointer;
  }
`;

export const CheckInput = styled.div`
  h3 {
    font-size: 22px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
    margin-bottom: 8px;
  }
`;

export const Reports = styled.div`
  div {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
    align-items: center;
    gap: 10px;

    button {
      width: 119px;
      height: 40px;
      margin-left: -12px;
      color: #fff;
      border-color: transparent;
      border-radius: 0px 5px 5px 0px;
      background: var(--color-primary);
      cursor: pointer;

      .ui.loader:after {
        border-color: #fff transparent transparent;
      }
    }
    .disable {
      background-color: #96989a;
      cursor: not-allowed;

      &:hover {
        background-color: #96989a;
      }
    }
  }

  h2 {
    font-size: 22px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
    margin: 0;
    margin-top: 40px;
  }
`;

export const InputDateTime = styled.input`
  border: 1px solid #96989a;
  height: 2.7rem;
  max-width: 200px;
  border-radius: 5px;
  padding: 0.2rem;
`;

export const LinkButton = styled.a`
  padding: 0.5rem 1rem;
  background: var(--color-success);
  border-radius: 1rem;
  color: #fff;
  transition: var(--transition);

  &:hover {
    color: #fff;
    background: var(--color-success-dark);
  }
`;
